// extracted by mini-css-extract-plugin
export default {"container":"D0-z","title":"E0-z","link":"F0-z"};